
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StateService } from '@uirouter/angular';
import { TrackeritemMultiUpdateModalComponent } from '../../trackeritemMultiUpdateModal/trackeritem.multi.update.modal.component';
import { TrackeritemMultiDeleteModalComponent } from '../../trackeritemMultiDeleteModal/trackeritem.multi.delete.modal.component';
import { getParamsFromAllowedKeys } from '../../../../../core/config/core.httpclient-utils';
import { GfTranslateService } from '../../../../../core/services/core.translate.service';
import * as _ from 'lodash';

@Component({
  selector: 'trackeritem-browse-toolbar',
  template: require('./trackeritem.browse.toolbar.component.html'),
})
export class TrackeritemBrowseToolbarComponent implements OnInit {
    @Input() tracker;
    @Input() trackeritems;
    @Input() options;
    @Input() acls;
    @Input() projectTrackers;
    @Input() selectedItems;
    @Input() autoRefresh;

    @Output() onUpdate: EventEmitter<any> = new EventEmitter<any>();
    @Output() onPage: EventEmitter<any> = new EventEmitter<any>();
    @Output() onSettingsUpdate: EventEmitter<any> = new EventEmitter<any>();

    query: any;
    openDialogDebounced: any;
    allChecked: boolean;
    copyTooltip: string;

    constructor(
        private modalService: NgbModal,
        private stateService: StateService,
        private translateService: GfTranslateService,
    ) {
        this.copyTooltip = this.translateService.translate('Copy URL to clipboard');
    }

    ngOnInit(): void {
        this.query = _.get(this.stateService.params, 'query', 0);
        this.openDialogDebounced = _.debounce(this.openDialog.bind(this), 200);
    }

    openTrackeritemMultiUpdateModal(): void {
        this.openDialogDebounced();
    }

    openDialog(): void {
        const modalRef = this.modalService.open(TrackeritemMultiUpdateModalComponent);
        modalRef.componentInstance.tracker = this.tracker;
        modalRef.componentInstance.trackeritems = this.selectedTrackerItems();

        // Listen to the EventEmitter
        modalRef.componentInstance.onUpdate.subscribe(($event) => {
            modalRef.close();
            this.onMultiEdit($event);
        });

        modalRef.componentInstance.onClose.subscribe(($event) => {
            modalRef.close();
        });
    }

    onMultiEdit(event) {
        this.onUpdate.emit(event);
    }

    exportQuery(format: string) {
        if (_.isEmpty(this.trackeritems) || _.get(this.acls, 'canRead', false) == false) return;

        //ToDo: change this to use angular's route object when 
        //the router is migrated to angular from angularjs
        const params = { ...this.stateService.params };

        //if it's a custom query, remove it from the params
        if (params['query']?.match(/custom/)) {
            //Add tracker parameter
            params['tracker'] = this.tracker.id;
            delete params['query'];
        }

        params['page_size'] = 0;
        params['format'] = format;
        params['download'] = true;

        // Only include API-relevant params using whitelist
        const allowedKeys = ['unixName', 'tracker', 'query', 'page_size', 'page_num', 'sort_field', 'sort_dir', 'filters', 'format', 'download'];
        const queryString = getParamsFromAllowedKeys(params, allowedKeys).toString();

        window.open("/api/trackeritem?" + queryString, '_blank'); // Open in a new tab
    }

    openDeleteModal() {
        const tids = this.selectedTrackerItems().map((item) => item.id);

        const modalRef = this.modalService.open(TrackeritemMultiDeleteModalComponent);
        modalRef.componentInstance.trackeritemids = tids;

        // Listen to the EventEmitter
        modalRef.componentInstance.onUpdate.subscribe(($event) => {
            modalRef.close();
            this.onUpdate.emit();
        });

        modalRef.componentInstance.onClose.subscribe(($event) => {
            modalRef.close();
        });
    }

    selectedTrackerItems() {
        if (_.isEmpty(this.selectedItems)) return [];
        return _.filter(this.trackeritems, item => _.includes(this.selectedItems, item.id));
    };

    anyItemsSelected() {
        return this.selectedItems.length > 0;
    }

    goTo(state: string, params: any) {
        this.stateService.go(state, params);
    }

    toggleAutoRefresh() {
        const newValue = this.autoRefresh ? 0 : 1;
        this.onSettingsUpdate.emit({settingName: 'autoRefresh', settingValue: newValue });
    }

    refresh() {
        this.onUpdate.emit();
    }

    get currentUrl(): string {
        return window.location.href;
    }

    onUrlCopied(success: boolean): void {
        this.copyTooltip = this.translateService.translate(success ? 'Copied!' : 'Copy failed');
        setTimeout(() => this.copyTooltip = this.translateService.translate('Copy URL to clipboard'), 2000);
    }
}
